// @flow
import React from 'react'

const Favorite = props => {
  const pathProps = props.pathProps || {}
  const svgProps = props.svgProps || {}
  return (
    <svg width="12px" height="10px" viewBox="0 0 12 10" version="1.1" xmlns="http://www.w3.org/2000/svg" {...svgProps}>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Heart-No" transform="translate(-2.000000, -3.000000)" fill="#E2E4E6">
          <path
            d="M13.9950222,6.49893855 C13.873826,9.05696823 12.1392797,10.3422313 9.98954636,12.246695 C8.85678147,13.2501624 7.16123401,13.2501624 6.02426924,12.2523184 C3.88893542,10.3778463 2.09439103,9.06696541 2.00259387,6.42021072 C1.88739744,3.09427228 5.63668125,1.73278067 7.76661525,4.44639153 C7.88301164,4.59509966 8.11580443,4.59197554 8.23160084,4.44326741 C10.3543351,1.72028419 14.1564172,3.0998957 13.9950222,6.49893855"
            id="love-[#1488]"
            {...pathProps}
          />
        </g>
      </g>
    </svg>
  )
}

Favorite.displayName = 'Favorite'

export default Favorite
